module.exports = __webpack_public_path__ + "img/gongshi.60fc612.png";